module.exports = __webpack_public_path__ + "img/icon5.ab69b599.png";